import React from "react";
import { Link } from "react-router-dom";

interface NewUsersStatsProps {
    data: {
        last24h: {
            total: number;
            paid_structure: number;
        };
        last7d: {
            total: number;
            paid_structure: number;
        };
        last30d: {
            total: number;
            paid_structure: number;
        };
    };
}

export const NewUsersStats: React.FC<NewUsersStatsProps> = ({ data }) => {
    return (
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                Новые пользователи{" "}
                <small>
                    (
                    <Link to="/dashboard/users" className="text-blue-500 underline hover:text-blue-600">
                        Посмотреть всех
                    </Link>
                    )
                </small>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="p-4 rounded-md border border-gray-200 dark:border-gray-700">
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        За 24 часа
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {data.last24h.total}
                    </div>
                    <div className="text-sm text-green-600 dark:text-green-400">
                        Оплатили структуру: {data.last24h.paid_structure}
                    </div>
                </div>
                <div className="p-4 rounded-md border border-gray-200 dark:border-gray-700">
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        За 7 дней
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {data.last7d.total}
                    </div>
                    <div className="text-sm text-green-600 dark:text-green-400">
                        Оплатили структуру: {data.last7d.paid_structure}
                    </div>
                </div>
                <div className="p-4 rounded-md border border-gray-200 dark:border-gray-700">
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        За 30 дней
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {data.last30d.total}
                    </div>
                    <div className="text-sm text-green-600 dark:text-green-400">
                        Оплатили структуру: {data.last30d.paid_structure}
                    </div>
                </div>
            </div>
        </div>
    );
};
